import createCachedSelector from 're-reselect';

const getCategory = (state, { data: { category } }) => category;
const getQualities = ({ myself: { qualities } }) => qualities;
const cacheKey = getCategory;

const inputs = [getCategory, getQualities];
const output = (category, qualities) => qualities.filter(q => q.category === category);

export default createCachedSelector(inputs, output)(cacheKey);